const ListItem = ({item, isActive, setIsActive, index}) => {
    return (
        <li className={`list-item ${isActive === index ? 'active' : ''}`}
            onClick={() => setIsActive(index)} dangerouslySetInnerHTML={{__html: item.name}}/>
    )
}


export default ListItem